import { FaInstagram, FaSnapchatGhost } from "react-icons/fa";
import { Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";

export const BUSINESS_EMAIL = "project941parties@gmail.com";

export const SOCIALS = [
  { id: "instagram", label: "Instagram", handle: "@project_parties.941", href: "https://www.instagram.com/project_parties.941?stkn=NnYwaTIwdjc0Z21h&utm_source=qr", Icon: FaInstagram },
  { id: "snapchat", label: "Snapchat", handle: "Add us on Snap", href: "https://snapchat.com/t/kRWJqjlc", Icon: FaSnapchatGhost },
];

export const SocialIcons = ({ prefix = "social", tone = "light", className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {SOCIALS.map(({ id, label, href, Icon }) => (
      <a
        key={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid={`${prefix}-${id}-link`}
        className={`w-12 h-12 flex items-center justify-center border-2 transition-[background-color,color,transform] duration-200 hover:-translate-y-1 ${tone === "light" ? "border-white text-white hover:bg-white hover:text-[#E10600]" : "border-[#0B0B0B] text-[#0B0B0B] hover:bg-[#0B0B0B] hover:text-white"}`}
      >
        <Icon className="w-5 h-5" />
      </a>
    ))}
  </div>
);

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="bg-white px-5 sm:px-10 lg:px-16 py-24 md:py-32 border-t-4 border-[#0B0B0B]">
    <Reveal>
      <p className="font-mono-x uppercase text-xs tracking-[0.25em] text-[#E10600] font-bold">Contact the squad</p>
      <h2 className="font-display uppercase text-5xl sm:text-7xl lg:text-8xl leading-[0.88] mt-4">
        Questions? <br /><span className="text-[#E10600]">Hit us up.</span>
      </h2>
    </Reveal>
    <div className="mt-12 grid lg:grid-cols-12 gap-4">
      <Reveal className="lg:col-span-6">
        <a
          href={`mailto:${BUSINESS_EMAIL}`}
          data-testid="contact-email-link"
          className="group h-full flex flex-col justify-between gap-10 bg-[#E10600] text-white p-6 sm:p-8 shadow-[8px_8px_0_#0B0B0B] transition-transform duration-200 hover:-translate-y-1"
        >
          <span className="flex items-center justify-between">
            <Mail className="w-8 h-8" />
            <ArrowUpRight className="w-7 h-7 transition-transform duration-300 group-hover:rotate-45" />
          </span>
          <span>
            <span className="block font-mono-x uppercase text-xs tracking-[0.25em]">Business email</span>
            <span className="block font-display text-2xl sm:text-4xl lg:text-[2.6rem] mt-2 break-all" data-testid="contact-email-text">{BUSINESS_EMAIL}</span>
            <span className="block mt-3 font-semibold">Orders, collabs, bookings or any questions — we'll get back to you.</span>
          </span>
        </a>
      </Reveal>
      {SOCIALS.map(({ id, label, handle, href, Icon }, i) => (
        <Reveal key={id} delay={0.08 * (i + 1)} className="lg:col-span-3">
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`contact-${id}-link`}
            className="group h-full min-h-[220px] flex flex-col justify-between bg-[#0B0B0B] text-white p-6 sm:p-8 transition-colors duration-300 hover:bg-[#E10600]"
          >
            <span className="flex items-center justify-between">
              <Icon className="w-10 h-10" />
              <ArrowUpRight className="w-7 h-7 transition-transform duration-300 group-hover:rotate-45" />
            </span>
            <span>
              <span className="block font-mono-x uppercase text-xs tracking-[0.25em] text-zinc-300 group-hover:text-white">{label}</span>
              <span className="block font-display uppercase text-3xl mt-2">{handle}</span>
            </span>
          </a>
        </Reveal>
      ))}
    </div>
  </section>
);
